
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#ABAFB5","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_70_43671)"}},[_c('path',{attrs:{"d":"M10.5.5H2a1 1 0 00-1 1V10a1 1 0 001 1h8.5a1 1 0 001-1V1.5a1 1 0 00-1-1z"}}),_c('path',{attrs:{"d":"M14 3.5v9a1 1 0 01-1 1H4"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_70_43671"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    